import type { ReactNode } from 'react';
import React from 'react';

function Content({ children }: { children?: ReactNode }) {
  return <div className="Offer-text">{children}</div>;
}

Content.displayName = 'Content';

export { Content };
